import './extensions/arrayExtensions';
import './extensions/objectExtensions';
import './extensions/stringExtensions';
import Rest from './rest';
import ImageObserver from './imageObserver';

const init = (() => {
  // TODO: PLACE CODE THAT NEEDS TO BE INITIALIZED HERE.

  Rest.init();
  ImageObserver.lazyLoad();
})();

export default init;
